(function() {
  var reviewTitleFallback = "Customer review";

  function isEmptyHeading(heading) {
    var text = heading.textContent ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
    if (text) {
      return false;
    }
    var img = heading.querySelector('img[alt]:not([alt=""])');
    return !img;
  }

  function fixEmptyYotpoReviewTitles(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('h1.yotpo-review-title, h2.yotpo-review-title, h3.yotpo-review-title, h4.yotpo-review-title, h5.yotpo-review-title, h6.yotpo-review-title').forEach(function(heading) {
      if (!isEmptyHeading(heading)) {
        return;
      }
      var reviewRoot = heading.closest('.yotpo-review, [class*="yotpo-review"]');
      var reviewBody = reviewRoot ? reviewRoot.querySelector('.yotpo-review-content, [class*="review-content"]') : null;
      var bodyText = reviewBody && reviewBody.textContent ? reviewBody.textContent.replace(/\s+/g, ' ').trim() : '';
      if (bodyText) {
        heading.textContent = reviewTitleFallback;
        return;
      }
      heading.remove();
    });
  }

  function initYotpoA11y() {
    fixEmptyYotpoReviewTitles(document);
    if (window.__yotpoA11yObserver) {
      return;
    }
    window.__yotpoA11yObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) {
            return;
          }
          if (node.matches && node.matches('.yotpo-review-title, [class*="yotpo"]')) {
            fixEmptyYotpoReviewTitles(node);
          } else {
            fixEmptyYotpoReviewTitles(node);
          }
        });
      });
    });
    window.__yotpoA11yObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYotpoA11y);
  } else {
    initYotpoA11y();
  }
  window.addEventListener('load', function() {
    fixEmptyYotpoReviewTitles(document);
  });

  [500, 1500, 3000, 6000, 10000].forEach(function(delayMs) {
    window.setTimeout(function() {
      fixEmptyYotpoReviewTitles(document);
    }, delayMs);
  });
})();
